<div class="pure-g">
  <div class="pure-g pure-u-md-20-24 pure-u-lg-21-24" style="overflow: auto; text-wrap: nowrap">
    <div style="width: 90px; display: inline-block; font-size: 0.9rem"></div>
  </div>
</div>
<div class="pure-g m-t-8 quick-filter-box">
  <div class="applied-filter-holder pure-u-md-20-24 pure-u-lg-20-24">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>
      @if (isArrayType(taggedFilter.value)) {
        @if (taggedFilter.key == 'Equipment ID') {
          <app-tag-with-overflow
            [data]="getTaggedEquipmentNumbers()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectEquipmentNumber()"></app-tag-with-overflow>
        }
        @if (taggedFilter.key == 'Location Code') {
          <app-tag-with-overflow
            [data]="getTaggedLocationCode()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectLocationCode()"></app-tag-with-overflow>
        }
        @if (taggedFilter.key == 'Profile') {
          <app-tag-with-overflow
            [data]="getTaggedProfiles()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectProfile()"></app-tag-with-overflow>
        }

        <!-- @else if (taggedFilter.key == "Profile" && getTaggedProfiles()) {
        @for (taggedProfile of getTaggedProfiles(); track taggedProfile) {
        <mc-tag class="m-r-4 extra-height" appearance="neutral-inverse" fit="small" withaction
            (click)="unselectSpecificFilter(taggedFilter, getTaggedProfiles().indexOf(taggedProfile))">{{
            getTaggedFilterValue(taggedFilter, getTaggedProfiles().indexOf(taggedProfile)) }}</mc-tag>
        }
        } -->
        @else if (taggedFilter.key == 'Production Year' && getTaggedProductionYear()) {
          @for (taggedProductionYear of getTaggedProductionYear(); track taggedProductionYear) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedProductionYear().indexOf(taggedProductionYear))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedProductionYear().indexOf(taggedProductionYear)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Equipment Group' && getTaggedEquipmentGroup()) {
          @for (taggedEquipmentGroup of getTaggedEquipmentGroup(); track taggedEquipmentGroup) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedEquipmentGroup().indexOf(taggedEquipmentGroup))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedEquipmentGroup().indexOf(taggedEquipmentGroup)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Equipment Owner' && getTaggedEquipmentOwner()) {
          @for (taggedEquipmentOwner of getTaggedEquipmentOwner(); track taggedEquipmentOwner) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedEquipmentOwner().indexOf(taggedEquipmentOwner))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedEquipmentOwner().indexOf(taggedEquipmentOwner)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Equipment Manufacturer' && getTaggedEquipmentManufacturer()) {
          @for (taggedEquipmentManufacturer of getTaggedEquipmentManufacturer(); track taggedEquipmentManufacturer) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedEquipmentManufacturer().indexOf(taggedEquipmentManufacturer))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedEquipmentManufacturer().indexOf(taggedEquipmentManufacturer)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Equipment Reefer Type' && getTaggedEquipmentReeferType()) {
          @for (taggedEquipmentReeferType of getTaggedEquipmentReeferType(); track taggedEquipmentReeferType) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedEquipmentReeferType().indexOf(taggedEquipmentReeferType))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedEquipmentReeferType().indexOf(taggedEquipmentReeferType)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Container Type' && getTaggedContainerType()) {
          @for (taggedContainerType of getTaggedContainerType(); track taggedContainerType) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedContainerType().indexOf(taggedContainerType))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedContainerType().indexOf(taggedContainerType)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Is Sales') {
          <mc-tag
            class="m-r-4 extra-height"
            appearance="neutral-inverse"
            fit="small"
            withaction
            (click)="unselectSpecificFilter(taggedFilter)"
            >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
          >
        }
      } @else {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      }
    }
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button class="clear-btn" variant="plain" appearance="primary" fit="small" padding="default" (click)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>
  <div class="utility-buttons pure-u-md-4-24 pure-u-lg-4-24">
    <!-- <div>
            <mc-button class="utility-button download" label="Button " variant="filled" appearance="neutral"
                fit="medium" [loading]="isDownload" icon="tray-arrow-down" hiddenlabel padding="default" (click)="onDownload()">
            </mc-button>
        </div> -->
    <div class="pure-g">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button"
          slot="trigger"
          label="Button"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="showAdvanceFiltersModal()">
        </mc-button>
        <span>Filters</span>
      </mc-tooltip>
      <mc-modal
        backdropcloseactiondisabled
        [open]="showAdvanceFilters"
        (closed)="closeAdvanceFiltersModal()"
        heading="Filters"
        fit="small"
        dimension="large">
        <app-dmrl-advance-filter [dmrlFilterForm]="filterFormGroup.controls.dmrlFilterForm"></app-dmrl-advance-filter>
      </mc-modal>
    </div>
  </div>
</div>
